import type { LoginGGParams } from '../types/indentityLoginType'
import { apiLoginGG } from './indentityLogin.urls'

export const loginGG = ({ returnUrl }: LoginGGParams) => {
  const root = window.env?.API_URL || import.meta.env.VITE_REACT_APP_API_ROOT

  return `${root}${apiLoginGG}?returnUrl=${encodeURIComponent(returnUrl)}`
}
const identityLoginService = {
  loginGG,
}

export default identityLoginService
